var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutLeadershipBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1520px",
    height: "792.455px",
    viewBox: "0 0 1520 792.455",
    enableBackground: "new 0 0 1520 792.455",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M361.94,195.881"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 210.249,
    cy: 165.031,
    r: 4.498
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M137.184,150.797c0,2.481-2.009,4.494-4.498,4.494c-2.481,0-4.49-2.013-4.49-4.494 c0-2.485,2.009-4.497,4.49-4.497C135.175,146.3,137.184,148.312,137.184,150.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M306.784,173.622c0,2.482-2.009,4.494-4.497,4.494c-2.481,0-4.498-2.012-4.498-4.494 c0-2.484,2.017-4.497,4.498-4.497C304.775,169.125,306.784,171.138,306.784,173.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M149.46,223.2c0,2.485-2.016,4.497-4.497,4.497c-2.489,0-4.498-2.012-4.498-4.497 c0-2.481,2.009-4.497,4.498-4.497C147.444,218.703,149.46,220.719,149.46,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M311.202,281.86c0,2.485-2.009,4.497-4.498,4.497c-2.481,0-4.497-2.012-4.497-4.497 c0-2.481,2.016-4.494,4.497-4.494C309.193,277.366,311.202,279.379,311.202,281.86z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 176.867,
    cy: 321.868,
    r: 4.497
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 223.873,
    cy: 251.938,
    r: 4.498
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M243.274,309.441c0,2.481-2.017,4.494-4.498,4.494s-4.497-2.013-4.497-4.494 c0-2.485,2.016-4.497,4.497-4.497S243.274,306.956,243.274,309.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M277.296,203.03c0,2.482-2.009,4.494-4.497,4.494c-2.481,0-4.498-2.012-4.498-4.494 c0-2.484,2.017-4.497,4.498-4.497C275.287,198.533,277.296,200.546,277.296,203.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M138.58,368.812c0,2.481-2.008,4.493-4.49,4.493c-2.488,0-4.497-2.012-4.497-4.493 c0-2.485,2.009-4.498,4.497-4.498C136.572,364.313,138.58,366.326,138.58,368.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M329.657,442.849c0,2.485-2.009,4.497-4.49,4.497c-2.488,0-4.497-2.012-4.497-4.497 c0-2.481,2.009-4.494,4.497-4.494C327.648,438.354,329.657,440.367,329.657,442.849z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M214.914,455.896c0,2.482-2.017,4.494-4.498,4.494s-4.497-2.012-4.497-4.494 c0-2.485,2.016-4.497,4.497-4.497S214.914,453.411,214.914,455.896z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 114.972,
    cy: 563.021,
    r: 4.498
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M256.737,515.387c0,2.481-2.009,4.497-4.498,4.497c-2.481,0-4.489-2.016-4.489-4.497 c0-2.485,2.008-4.498,4.489-4.498C254.729,510.889,256.737,512.901,256.737,515.387z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 390.213,
    cy: 561.507,
    r: 4.498
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M126.85,446.454c0,2.481-2.009,4.494-4.498,4.494c-2.481,0-4.49-2.013-4.49-4.494 c0-2.485,2.009-4.497,4.49-4.497C124.841,441.957,126.85,443.969,126.85,446.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 315.422,
    cy: 369.706,
    r: 4.498
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    cx: 142.75,
    cy: 281.616,
    r: 4.498
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M307.52,225.656c0,2.481-2.009,4.494-4.49,4.494c-2.489,0-4.498-2.013-4.498-4.494 c0-2.485,2.009-4.497,4.498-4.497C305.511,221.159,307.52,223.171,307.52,225.656z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 363.374,526.492 327.351,446.454 315.423,369.706 307.432,284.848 304.739,225.864 317.708,203.03 317.708,150.135  302.294,150.135 302.294,173.539 272.799,203.03 272.799,150.135 239.693,150.135 239.693,177.916 224.854,177.916  210.009,177.916 210.009,150.135 176.903,150.135 176.903,203.03 147.415,173.539 147.415,150.135 132.002,150.135  132.002,203.03 144.97,225.864 142.277,284.848 134.287,369.706 122.352,446.454 86.336,526.492 58.936,534.101 58.936,563.021  224.854,563.021 390.767,563.021 390.767,534.101  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 317.708,203.03 294.158,181.672 303.327,224.227 142.401,282.126 242.168,308.933 307.309,282.122 144.97,225.864 176.903,203.03  239.693,177.916 272.799,203.03 304.739,225.864 239.133,311.298 327.351,446.454 208.597,453.929 252.239,515.387  254.394,515.619 361.896,527.369 390.767,563.021 252.437,514.622 114.973,563.021 60.843,533.573  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 317.708,150.135 302.294,173.539 317.708,201.091 281.088,194.738 146.243,224.219 176.78,320.562 134.287,369.706  325.764,442.324 142.401,281.02 177.449,200.844 209.602,164.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 147.415,173.539 132.409,203.748 159.016,185.143 144.33,224.739 164.735,192.471 239.133,311.298 134.287,369.706  208.597,453.929 122.352,446.454 176.78,320.562 361.896,527.369 300.417,561.049 208.626,512.959 58.936,563.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 86.336,526.492 114.973,563.021 212.381,453.691  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 86.336,526.492 252.247,404.867 313.414,370.467 237.969,309.438 210.416,455.896 363.374,526.492  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 208.626,
    y1: 512.959,
    x2: 325.764,
    y2: 442.324
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M110.795,472.144l-94.549,54.701 c-16.403,9.505-16.301,33.226,0.183,42.588l197.757,112.342c7.504,4.265,16.695,4.272,24.213,0.025l228.737-129.364 c7.619-4.308,16.956-4.231,24.511,0.197l100.858,93.133h344.863l315.544-211.439c15.704-9.198,16.286-31.693,1.077-41.692 l-64.719-42.563c-15.151-9.962-14.643-32.352,0.946-41.615l115.304-68.511c15.355-9.126,16.134-31.067,1.47-41.263l-101.025-70.221 c-7.802-5.421-18.033-5.858-26.271-1.113l-116.49,67.109c-8.362,4.817-18.769,4.29-26.599-1.35l-90.066-64.835 c-7.933-5.713-18.499-6.172-26.897-1.176L721.628,244.945c-7.678,4.566-17.232,4.606-24.946,0.095L491.93,125.329 c-7.735-4.52-17.32-4.472-25.005,0.135l-160.476,96.193"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLeadershipBg);
export default __webpack_public_path__ + "static/media/aboutLeadershipBg.b63117e9278f0b5aa10b775a2fb6a000.svg";
export { ForwardRef as ReactComponent };